export enum Layout {
  Basic = 'BASIC',
  Primary = 'PRIMARY',
  Minimal = 'MINIMAL',
}
